import React from 'react';

import PropTypes from 'prop-types';

import A from 'wanderu-component-react-router-link';

function BranchLink(props) {
    const {
        className,
        children,
    } = props;

    return (
        <A
            className={className}
            href="/app"
            target="_blank"
        >
            {children}
        </A>
    );
}

BranchLink.propTypes = {
    className: PropTypes.string,
};

export default BranchLink;
